<div fxLayout="column" fxLayoutAlign="center center">
  <div class="next-steps">
    <h1>Discipleship Path <strong>SERVING</strong> Next Steps</h1>
    <p>With respect to <strong>SERVING</strong>, below are considerations to enhance your spiritual walk in Christ.</p>
  </div>
  <hr class="divider" />
  <div class="exploring-christ">
    <h2>Exploring Christ</h2>
    <ul>
      <li>Explore your spiritual gifts by taking the spiritual gift assessment.<a href="https://gifts.churchgrowth.org/spiritual- gifts-survey/" target="_blank"> [Spiritual Gifts Assessment]</a>
      </li>
      <li>
        <a href="https://biblia.com/bible/esv/1-corinthians/12/1-11" target="_blank"> [1 Corinthians 12:1-11]</a>
      </li>
    </ul>
  </div>
  <div class="growing-in-christ">
    <h2>Growing In Christ</h2>
    <ul>
      <li>
        Pick your top 3 dominant gifts.
      </li>
      <li>
        Evaluate the needs and <strong>SERVING</strong> opportunities at the church.
      </li>
      <li>
        Pray about which area(s) you want to get more involved in at the church.
      </li>
      <li>
        <a href="https://biblia.com/bible/esv/romans/12/4-8" target="_blank"> [Romans 12:4-8]</a>
      </li>
    </ul>
    <p class="tip">Tip: Don't limit your gifts or <strong>SERVING</strong> opportunities to what shows up on the spiritual gift assessment, just use it as a starting point/guide.</p>
    <p class="tip">Tip: Don't doubt your gifts.</p>
  </div>
  <div class="close-to-christ">
    <h2>Close To Christ</h2>
    <ul>
      <li>
        Use your gifts by <strong>SERVING</strong> in different areas in this church.
      </li>
      <li>
        <a href="https://biblia.com/bible/esv/1-peter/4/10-11" target="_blank"> [1 Peter 4:10-11]</a>
      </li>
      <li>
        <a href="https://biblia.com/bible/esv/james/2/14-26" target="_blank"> [James 2:14-26]</a>
      </li>
    </ul>
  </div>
  <div class="christ-centered">
    <h2>Christ-Centered</h2>
    <ul>
      <li>
        Start <strong>SERVING</strong> on a regular basis at the church.
      </li>
      <li>
        Encourage others to <strong>SERVE</strong> as well.
      </li>
      <li>
        <a href="https://biblia.com/bible/esv/ephesians/8/8-10" target="_blank"> [Ephesians 2:8-10]</a>
      </li>
    </ul>
    <p class="tip">Tip: Don't over commit.</p>
    <p class="tip">Tip: Always remember the reason why you're <strong>SERVING</strong> is to bring honor and glory to God and to be the hands and feet of Jesus.</p>
    <p class="tip">Tip: Remember we are only saved by grace alone, not by works.</p>
  </div>
</div>